const { REACT_APP_PROTOCOL, REACT_APP_HOST, REACT_APP_PORT } = process.env;

const BASE_URL = `${REACT_APP_PROTOCOL}://${REACT_APP_HOST}:${REACT_APP_PORT}`;

export function getImageUrl(path) {
  if (!path) {
    return 'https://dummyimage.com/1024x800/bababa/f5f5f5.png&text=X';
  }

  // pastikan path selalu diawali dengan "/"
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${BASE_URL}${normalizedPath}`;
}
